<template>
    <b-button-group class="mx-1" size="sm">
        <b-button
            @click.prevent="remove"
            variant="secondary"><i class="las la-trash"></i>
        </b-button>
    </b-button-group>
</template>
<script>
export default {
    name: 'btn-delete-product',
    props: {
        value: {},
        province_name: {},
        index: {}
    },
    methods: {
        remove() {
            this.value[this.province_name].splice(this.index, 1)
        }
    }
}
</script>
